// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_VWNuM","separator":"index_separator_3KOjd"};